import {Label} from 'platform/components';
import {Text, VStack} from 'platform/foundation';
import styled from 'styled-components';

import {AuctionVehicleResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';

import {EMPTY_PLACEHOLDER, suffixTestId, TestIdProps} from 'shared/web';

/** Narrowest identifier column (in space steps, 36 = 144px), long enough for a VIN. */
const IDENTIFIER_MIN_WIDTH = 36;

/** As many columns as fit the preview; a narrow preview stacks the identifiers. */
const IdentifierGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(min(100%, ${({theme}) => theme.getSize(IDENTIFIER_MIN_WIDTH)}), 1fr)
  );
  gap: ${({theme}) => theme.getSize(3)};
`;

interface AuctionIdentifiersProps extends TestIdProps {
  auctionVehicle: AuctionVehicleResponseBody;
}

export function AuctionIdentifiers(props: AuctionIdentifiersProps) {
  const identifiers = [
    {
      key: 'auctionId',
      label: i18n.t('entity.auction.labels.auctionIdLabel'),
      value: props.auctionVehicle.auctionId,
    },
    {key: 'carId', label: i18n.t('entity.auction.labels.carId'), value: props.auctionVehicle.pk},
    {key: 'vin', label: i18n.t('entity.vehicle.labels.vin'), value: props.auctionVehicle.vin},
  ];

  return (
    <IdentifierGrid data-testid={props['data-testid']}>
      {identifiers.map((identifier) => (
        <VStack key={identifier.key} spacing={1}>
          <Label>{identifier.label}</Label>
          <Text
            size="small"
            alternative
            overflowWrap="anywhere"
            data-testid={suffixTestId(identifier.key, props)}
          >
            {identifier.value ?? EMPTY_PLACEHOLDER}
          </Text>
        </VStack>
      ))}
    </IdentifierGrid>
  );
}
